import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Input } from '@/components/ui/input'

interface CustomStatusCommentDialogProps {
  isOpen: boolean
  onClose: () => void
  onSubmit: (comment: string) => void
  isLoading?: boolean
}

export function CustomStatusCommentDialog({
  isOpen,
  onClose,
  onSubmit,
  isLoading = false,
}: CustomStatusCommentDialogProps) {
  const { t } = useTranslation('orders')
  const [comment, setComment] = useState('')

  const handleSubmit = () => {
    const trimmed = comment.trim()
    if (!trimmed) return
    onSubmit(trimmed)
    setComment('')
  }

  const handleClose = () => {
    setComment('')
    onClose()
  }

  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => !open && handleClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('kanban.comment')}</AlertDialogTitle>
        </AlertDialogHeader>

        <Input
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder={t('kanban.commentPlaceholder')}
          className="tablet:text-kitchen-sm tablet:min-h-touch"
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSubmit()
          }}
          autoFocus
        />

        <AlertDialogFooter className="tablet:gap-3">
          <AlertDialogCancel
            onClick={handleClose}
            disabled={isLoading}
            className="tablet:min-h-touch tablet:text-kitchen-sm tablet:px-6"
          >
            {t('common.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleSubmit}
            disabled={isLoading || !comment.trim()}
            className="tablet:min-h-touch tablet:text-kitchen-sm tablet:px-6"
          >
            {t('kanban.commentSend')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
